<template>
    <div>
       <field-date  ref="input" :value="myValue" @change="updateValue" @input="inputValue" :disabled="disabled">
            <b class='gray' v-if="currentAge>0">{{currentAge}} anos </b>
        </field-date>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
    data(){
        return {
            myValue:''
        }
    },
    props:['value', 'disabled'],

    created:function(){
        this.myValue = this.value
    },
    watch:{
        value:function(val){
            this.myValue = val
        }
    },
    computed:{
        currentAge:function(){
               return Math.abs(moment(this.myValue).diff(moment(), 'years'))
        }
    },

    methods:{
        updateValue:function(val){
            this.myValue = val
            this.$emit('change',val)
            this.$emit('input',val)
        },
         inputValue:function(val){
            this.myValue = val
            this.$emit('input',val)
        },
    }
}
</script>

<style lang="stylus">

</style>
